module.exports = __webpack_public_path__ + "static/media/Rectangle 9 (1).e0f5df26.png";